Config = require('resources/assets/coffee/Core/LaravelJs/Config/Repository').Repository


class exports.Translator

    constructor: (config) ->
        @config = config

        @lang = new Config({})


    get: (key, replacements = [], lang = null) ->
        curr = lang ? @config.get('app.locale')

        mapping = @config.get('app.language_mapping.' + curr)

        val = @lang.get(curr + '.' + key)

        if not val?
            if mapping?
                return @get(key, replacements, mapping)

            return key

        if typeof val is 'string'
            return val.replace /: (\w+)/g, (match, contents) ->

                return replacements[contents] ? match

        return val


    choice: (key, number = 1, replacements = [], lang = null) ->
        val = @get(key, replacements, lang)

        parts = val.split('|')

        if parts.length is 1
            return parts[0]


        matches = 0

        for p in parts
            startnum    = null
            endnum      = null

            x = p.match(/\{(\d+)\}/)

            if x? and x.length > 1
                startnum    = x[1]
                endnum      = x[1]
            else
                x = p.match(/\[(\d+),(\d+)\]/)

                if x? and x.length > 2
                    startnum    = x[1]
                    endnum      = x[2]

            if startnum? and endnum?
                matches++
                if startnum <= number and endnum >= number
                    return p.replace(/\{\d+\}|\[\d+,\d+\]/, '').trim()


        if parts.length > 0 and matches < parts.length
            if number is 1
                return parts[0].trim()

            if matches is parts.length - 2
                return parts[1].trim()






        return key
